import TabsPage, { tabsFromResources } from "features/TabsPage";
import { campaignResources } from "./campaignResources";

// One tab per campaign type, derived from the (hidden) campaign resources — each tab renders
// that resource's list, while the resource itself stays registered (see app/resources.js)
// so its create/edit/show routes keep working.
const campaignTabs = tabsFromResources(campaignResources);

const CampaignsPage = () => (
  <TabsPage
    title="Кампании за прием"
    tabs={campaignTabs}
    placeholder="Изберете тип кампания, за да видите списъка."
  />
);

export default CampaignsPage;
